// extracted by css-extract-rspack-plugin
export default {"content":"UPDYSFyKkOIOUPxF","button":"_IjUVImlhpUWHAtT","privacyLink":"G4vPMkjswwgVGHPb"};